import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { TableSortIconPipe } from './table-sort-icon.pipe';

export type SortType = 'numeric' | 'alpha' | 'size';
export type SortDirection = 'asc' | 'desc';
export interface SortOption {
  id: string;
  type: SortType;
  label: string;
  defaultSort: SortDirection;
}

export interface Sort extends SortOption {
  direction: SortDirection;
}

export const oppositeSortDirection = (sort: SortDirection): SortDirection => {
  return sort === 'asc' ? 'desc' : 'asc';
};

export const NO_SORT: Sort = { id: 'none', label: 'uix.grid.options.sort.none', type: 'alpha', defaultSort: 'asc', direction: 'asc' };

@Component({
  imports: [CommonModule, MatButtonModule, MatIconModule, MatMenuModule, MatTooltipModule, TranslatePipe, TableSortIconPipe],
  selector: 'app-table-sort-options',
  templateUrl: './table-sort-options.component.html',
  styleUrls: ['./table-sort-options.component.scss'],
  standalone: true,
})
export class TableSortOptionsComponent {
  @Input()
  options: SortOption[] = [];

  @Output()
  sortChange: EventEmitter<Sort> = new EventEmitter<Sort>();

  @Input()
  appearance: 'button' | 'menu' = 'button';

  private _currentSort: Sort = NO_SORT;

  @Input()
  set currentSort(sort: Sort) {
    this._currentSort = sort || NO_SORT;
  }

  get currentSort(): Sort {
    return this._currentSort;
  }

  sort(option: SortOption): void {
    let direction = option.defaultSort;
    if (option.id === this.currentSort.id) {
      direction = this.currentSort.direction === 'asc' ? 'desc' : 'asc';
    }

    this.currentSort = { ...option, direction };
    this.sortChange.next(this.currentSort);
  }
}
